import { Global, css } from '@emotion/core';
import { Colors, Typography } from '@zapier/design-system';

const globalStyles = css({
  body: {
    fontFamily: Typography.base.fontFamily,
    fontStyle: 'normal',
    fontWeight: 'normal',
    margin: 0,
    backgroundColor: Colors.neutral100,
  },

  '*': {
    margin: 0,
    padding: 0,
  },
});

export function GlobalStyles() {
  return <Global styles={globalStyles} />;
}
